import { LayoutComponent } from '../layout/layout.component';
import { RegisterComponent } from './pages/register/register.component';
import { LockComponent } from './pages/lock/lock.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { Error404Component } from './pages/error404/error404.component';
import { Error500Component } from './pages/error500/error500.component';
import { AuthenticationGuard } from '../shared/guards/authentication.guard';
import { LoginComponent } from './login/login.component';
import { RecoverComponent } from './pages/password-recovery/recover.component';
import { ResetPasswordComponent } from './pages/password-recovery/reset-password.component';
import { MsalRedirectComponent} from "@azure/msal-angular";
import { SsoLogoutComponent } from "@app/routes/pages/sso-logout/sso-logout.component";

export const routes = [
	{
		path: '',
		component: LayoutComponent,
		canActivate: [ AuthenticationGuard ],
		children: [
			{
				path: 'dashboard',
				loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
				canActivate: [ AuthenticationGuard ]
			},
			{
				path: 'ticket',
				loadChildren: () => import('./ticket/ticket.module').then(m => m.TicketModule),
				canActivate: [ AuthenticationGuard ]
			},
			{ path: 'dna', loadChildren: () => import('./dna/dna.module').then(m => m.DnaModule), canActivate: [ AuthenticationGuard ] },
      { path: 'discipline', loadChildren: () => import('./disciplinemanagement/discipline.module').then(m => m.DisciplineModule), canActivate: [AuthenticationGuard] },
      { path: 'data-management', loadChildren: () => import('./data-management/data-management.module').then(m => m.DataManagementModule), canActivate: [AuthenticationGuard] },
			{
				path: 'administration',
				loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule),
				canActivate: [ AuthenticationGuard ]
			},
			{ path: 'cad', loadChildren: () => import('./cad/cad.module').then(m => m.CADModule), canActivate: [ AuthenticationGuard ] },
			{ path: 'aacs', loadChildren: () => import('./aacs/aacs.module').then(m => m.AACSModule), canActivate: [ AuthenticationGuard ] },
			{
				path: 'sharedfunctions',
				loadChildren: () => import('./sharedfunctions/sharedfunctions.module').then(m => m.SharedFunctionsModule),
				canActivate: [ AuthenticationGuard ]
			},
			{
				path: 'drawing-helper',
        loadChildren: () => import('./drawing-helper/drawing-helper.module').then(m => m.DrawingHelperModule),
			},
			{
				path: 'cad-library',
				loadChildren: () => import('./cad-library-view/cad-library-view.module').then(m => m.CadLibraryViewModule),
				canActivate: [ AuthenticationGuard ]
			},
			{
				path: 'administration/cad-library-management',
				loadChildren: () => import('./administration/cad-library/cad-library.module').then(m => m.CadLibraryModule),
				canActivate: [ AuthenticationGuard ]
			},
			{
				path: 'administration/suspicious-activity',
				loadChildren:
					() => import('./administration/suspicious-activity/suspicious-activity.module').then(m => m.SuspiciousActivityModule),
				canActivate: [ AuthenticationGuard ]
			},
			{ path: 'filemanagement', loadChildren: () => import('./filemanagement/filemanagement.module').then(m => m.FileManagementModule) },
			{ path: 'help', loadChildren: () => import('./help/help.module').then(m => m.HelpModule) },
			{
				path: 'clouddrive',
				loadChildren: () => import('./clouddrive/clouddrive.module').then(m => m.CloudDriveModule),
				canActivate: [ AuthenticationGuard ]
			},
			{
				path: 'unit-converter',
				loadChildren: () => import('./unit-converter/unit-converter.module').then(m => m.UnitConverterModule),
				canActivate: [ AuthenticationGuard ]
			},
			{
				path: 'administration/unit-conversion',
				loadChildren: () => import('./administration/unit-conversion/unit-conversion.module').then(m => m.UnitConversionModule),
				canActivate: [ AuthenticationGuard ]
			},
			{
				path: 'automation',
				loadChildren: () => import('./automation/automation.module').then(m => m.AutomationModule),
				canActivate: [ AuthenticationGuard ]
			},
      {
        path: 'commissioning-sheet',
        loadChildren: () => import('./commissioning-sheet/commissioning-sheet.module').then(m => m.CommissioningSheetModule),
        canActivate: [ AuthenticationGuard ]
      },
      {
        path: 'schematics',
        loadChildren: () => import('./schematics/schematics.module').then(m => m.SchematicsModule),
        canActivate: [ AuthenticationGuard ]
      }
		]
	},
	{	// Needed for handling redirect after login
		path: 'auth',
		component: MsalRedirectComponent
	},
	{
		path: 'sso-logout',
		component: SsoLogoutComponent
	},
	// Not lazy-loaded routes
	{ path: 'login', component: LoginComponent },
	{ path: 'register', component: RegisterComponent },
	{ path: 'recover', component: RecoverComponent },
	{ path: 'reset-password', component: ResetPasswordComponent },
	{ path: 'lock', component: LockComponent },
	{ path: 'maintenance', component: MaintenanceComponent },
	{ path: '404', component: Error404Component },
	{ path: '500', component: Error500Component },

	// Not found
	{ path: '**', redirectTo: 'home' }
];
